// extracted by mini-css-extract-plugin
export default {"cardHeader":"style_cardHeader__U0K8U","tableDiv":"style_tableDiv__mdSxH"};